import { type MaskConfig, usePhoneMask } from '@direct-frontend/components';
import { useMemo } from 'react';
import { transformPhonePreprocessor } from './lib/transformPhonePreprocessor';

export const useCustomPhoneMask = (props: Parameters<typeof usePhoneMask>[number] = {}): MaskConfig => {
    const phoneMask = usePhoneMask(props);

    return useMemo(
        () => ({
            ...phoneMask,
            maskitoOptions: {
                ...phoneMask.maskitoOptions,
                preprocessors: [transformPhonePreprocessor],
            },
        }),
        [phoneMask]
    );
};
